export default "__VITE_PUBLIC_ASSET__88b665df__"